export default __webpack_public_path__ + "static/media/google_play.93e8d43d.png";